import api from "./instance";

export default {
  fetchPayments: (token, userType, page) =>
    api
      .get(
        `/flutterwave/payment-logs?page=${page}&perPage=10&userType=${userType}`,
        {
          headers: { Authorization: token }
        }
      )
      .then(res => res),
  searchPayments: (token, searchInput) =>
    api
      .get(`/flutterwave/search-payment-logs?searchInput=${searchInput}`, {
        headers: { Authorization: token }
      })
      .then(res => res)
};
